// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2n0eq","gfeWrapper":"CalendarEvent_gfeWrapper__2q-4J"};